import { mainSiteUrl } from '@/mocks/categories';

const comparisonRows = [
  { feature: 'Product Discovery', vigorbuy: 'Fast & Organized', traditional: 'Slow & Scattered' },
  { feature: 'Categories', vigorbuy: '14 Curated Sections', traditional: 'Random & Unstructured' },
  { feature: 'Buying Guides', vigorbuy: 'Included & Detailed', traditional: 'Not Available' },
  { feature: 'Updates', vigorbuy: 'Weekly Refresh', traditional: 'Unknown Frequency' },
  { feature: 'User Experience', vigorbuy: 'Excellent & Intuitive', traditional: 'Average' },
];

export default function ComparisonSection() {
  return (
    <section className="relative py-20 md:py-28 px-6 md:px-10 lg:px-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-16 items-start">

          {/* Left Text */}
          <div className="lg:w-[42%]">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-semibold uppercase tracking-wider mb-6">
              Buy Smart
            </span>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-900 leading-tight">
              Compare.
              <br />
              Inspect.
              <br />
              Save.
            </h2>
            <p className="mt-6 text-foreground-500 text-base md:text-lg leading-relaxed max-w-md">
              The <strong className="font-semibold text-foreground-800">Vigorbuy Spreadsheet</strong> transforms how you discover products. Instead of endless searching, get organized collections, verified links, and expert guidance — all in one place.
            </p>

            {/* Mini Comparison Table */}
            <div className="mt-8 border border-background-200/80 rounded-2xl overflow-hidden">
              <div className="grid grid-cols-3 bg-foreground-900 text-background-50 text-xs font-semibold uppercase tracking-wider py-3 px-5">
                <span>Feature</span>
                <span className="text-center">Vigorbuy</span>
                <span className="text-center">Others</span>
              </div>
              {comparisonRows.map((row, i) => (
                <div
                  key={row.feature}
                  className={`grid grid-cols-3 py-3 px-5 text-sm ${
                    i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'
                  }`}
                >
                  <span className="text-foreground-700 font-medium">{row.feature}</span>
                  <span className="text-center text-accent-600 font-semibold">{row.vigorbuy}</span>
                  <span className="text-center text-foreground-400">{row.traditional}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Right Card - Guide */}
          <div className="lg:w-[55%]">
            <div className="bg-accent-500 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden">
              {/* Decorative elements */}
              <span className="absolute top-6 left-8 text-white/20 text-xs font-semibold uppercase tracking-[0.2em]">
                Quick Guide
              </span>
              <span className="absolute top-6 right-8 flex gap-1.5">
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
                <span className="w-2 h-2 rounded-full bg-white/30"></span>
              </span>

              {/* Guide Content */}
              <div className="mt-10 space-y-5">
                {[
                  'Always review product details and images carefully before ordering.',
                  'Compare multiple listings to find the best value for your budget.',
                  'Check sizing charts and measurements — sizes can vary between brands.',
                  'Read community reviews and QC feedback for real-world insights.',
                  'Use the updated vigorbuy spreadsheet for the latest verified links.',
                  'Bookmark your favorite categories for quick access during updates.',
                ].map((tip, i) => (
                  <div key={i} className="flex items-start gap-4">
                    <span className="w-6 h-6 flex items-center justify-center rounded-full bg-white/15 flex-shrink-0 mt-0.5">
                      <i className="ri-check-line text-xs"></i>
                    </span>
                    <p className="text-white/90 text-base leading-relaxed">{tip}</p>
                  </div>
                ))}
              </div>

              {/* Editor Info */}
              <div className="mt-10 pt-8 border-t border-white/15 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20friendly%20headshot%20of%20product%20curator%20with%20warm%20smile%2C%20clean%20soft%20grey%20background%2C%20soft%20studio%20lighting%2C%20genuine%20expression%2C%20minimalist%20editorial%20style%2C%20charcoal%20blazer%2C%20approachable%20authentic%20portrait&width=100&height=100&seq=editor-v3-avatar&orientation=squarish"
                      alt="Product Curator"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold">Alex Chen</p>
                    <p className="text-xs text-white/60">Product Curator</p>
                  </div>
                </div>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="flex items-center gap-2 px-5 py-2.5 rounded-full bg-white/15 text-sm font-medium hover:bg-white/25 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                >
                  View Spreadsheet
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}